import styled from 'styled-components';
import { Button } from '../../../../components/common/buttons/Button';
import { useGetMyOwnTractorById } from '../../../../hooks/api/user/queries/useGetMyOwnTractorById';
import { AnimateLoading } from '../../../../components/common/loading/AnimateLoading';

interface PokeRequestCheckModalBodyProps {
  ownTractorId: string;
  handleSellTractorClick: () => void;
  handleDisablePoke: () => void;
}

export const PokeRequestCheckModalBody = ({
  ownTractorId,
  handleSellTractorClick,
  handleDisablePoke,
}: PokeRequestCheckModalBodyProps) => {
  const { data: myOwnTractor, isLoading: isGetUsersOwnTractorLoading } = useGetMyOwnTractorById({
    ownTractorId,
  });

  if (isGetUsersOwnTractorLoading) {
    return <AnimateLoading />;
  }

  return (
    <InfoSection>
      <InfoTitleSection>
        <InfoTitle>
          {'다른 고객의 찔러보기 요청이\n'}
          <InfoTitleHighlight>{`누적 ${myOwnTractor?.pokeCount}건 `}</InfoTitleHighlight>
          {'도착 했어요!'}
        </InfoTitle>
      </InfoTitleSection>
      <InfoDescriptionSection>
        <InfoDescription>
          {`어제까지 다른 고객님들의\n찔러보기 요청이 총 누적 ${myOwnTractor?.pokeCount}건 도착했어요.\n판매 의향이 있으신가요?`}
        </InfoDescription>
      </InfoDescriptionSection>
      <ButtonGroup>
        <Button
          borderType={'square'}
          color={'filledPrimaryStrong'}
          size={'md'}
          text={{ content: '판매 할게요', size: 'md' }}
          onClick={() => handleSellTractorClick()}
        />
        <Button
          borderType={'square'}
          color={'filledPrimaryLight'}
          size={'md'}
          text={{ content: '판매 할 생각이 없어요', size: 'md' }}
          onClick={() => handleDisablePoke()}
        />
      </ButtonGroup>
    </InfoSection>
  );
};

const InfoSection = styled.div`
  display: flex;
  padding: 0px 24px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`;

const InfoTitleSection = styled.div`
  display: flex;
  padding-bottom: 24px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const InfoTitle = styled.h3`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const InfoTitleHighlight = styled.span`
  color: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const InfoDescriptionSection = styled.div`
  display: flex;
  max-height: 400px;
  padding-bottom: 24px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`;

const InfoDescription = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const ButtonGroup = styled.div`
  display: flex;
  padding-bottom: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
